import * as types from "./actiontype";
import quotationService from '../services/micustomerservice';
import * as appActions from '../../../actions/appactions';
import * as appConstants from '../../../overrides/appconstants';
import * as constants from '../constants';
import * as appUtilityFunction from "../../../infrastructure/apputilityfunctions";
import sharedGlobals from "../../../sharedglobals";
export const showMedicalQuote = () => {

  return {
    type: types.SHOW_MEDICAL_QUOTE,
  }

}

export const showMedicalServices = () => {

  return {
    type: types.SHOW_MEDICAL_SERVICES,
  }

}

export const getMICustomerMastersEnd = (result) => {
  return {
    type: types.GET_MI_CUSTOMER_MASTERS,
    result
  }
}

export const clearMemberDocument = () => {
  return {
    type: types.CLEAR_MEMBER_DOC,
  }
}

export const toggleBasePremModel = (result) => {
  return {
    type: types.TOGGLE_MEMBER_BASE_PREM_MODAL,
    result
  }
}
export const togglePlanSelectionModel = (result) => {
  return {
    type: types.TOGGLE_PLAN_SELECT_MODAL,
    result
  }
}


export const togglePlanTOBModel = (result) => {
  return {
    type: types.TOGGLE_PLAN_TOB_MODAL,
    result
  }
}

export const togglePlanCompare = (result) => {
  return {
    type: types.TOGGLE_PLAN_COMPARE,
    result
  }
}
export const saveMICustomerNewEnqEnd = (result) => {
  return {
    type: types.SAVE_MI_CUSTOMER_NEW_ENQUIRY,
    payload: result
  }
}
export const saveProspectDetailsEnd = (result) => {
  return {
    type: types.SAVE_PROSPECT_DETAILS,
    payload: result
  }
}

export const getQuoteMembersEnd = (result) => {
  return {
    type: types.GET_QUOTE_MEMBERS,
    payload: result
  }
}
export const saveMICustomeMemberBasicInfoEnd = (result) => {
  return {
    type: types.SAVE_BASIC_MEMBER_INFO,
    payload: result
  }
}
export const handleBasicInfoQuoteChange = ({ name, value }) => {
  return {
    type: types.UPDATE_BASIC_QUOTE_PARAMS,
    payload: { name, value }
  }
}

export const updateProspectInformationParams = ({ name, value, memberTypeState }) => {
  return {
    type: types.UPDATE_PROSPECT_INFORMATION_PARAMS,
    payload: { name, value, memberTypeState }
  }
}
export const updateMemberInformationParams = ({ name, value }) => {
  return {
    type: types.UPDATE_MEMBER_INFORMATION_PARAMS,
    payload: { name, value }
  }
}

export const getQuoteSearchResultEnd = (result) => {
  return {
    type: types.QUOTE_SEARCH_RESULT,
    payload: result
  }
}
export const getQuoteMemberDetailsResultEnd = (result) => {
  return {
    type: types.GET_MEMBER_DETAILS_BY_QUOTE_ID,
    payload: result
  }
}
export const handleQuoteSearchChange = ({ name, value }) => {
  return {
    type: types.UPDATE_QUOTE_SEARCH_PARAMS,
    payload: { name, value }
  }
}

export const handleNextStep = (step) => {
  return {
    type: types.HANDLE_NEXT_STEP,
    payload: step
  }
}

export const addSponserToQuote = () => {
  return {
    type: types.ADD_SPONSOR_TO_QUOTE
  }
}

export const updateBasicMemberInfo = ({ name, value }) => {
  return {
    type: types.UPDATE_BASIC_MEMBER_INFO,
    payload: { name, value }
  }
}
export const updateBasicMemberInfoList = ({ id, name, value }) => {
  return {
    type: types.UPDATE_BASIC_MEMBER_INFO_LIST,
    payload: { id, name, value }
  }
}

export const deleteMemberFromGrid = (srNo) => {
  return {
    type: types.DELETE_MEMBER,
    payload: srNo
  }
}

export const deleteAllMembers = () => {
  return {
    type: types.DELETE_ALL_MEMBERS,
  }
}

export const checkDocumentTabType = (type) => {
  return {
    type: types.CHECK_DOCUMENT_TAB_TYPE,
    payload: type
  }
}

export const addNewDocument = () => {
  return {
    type: types.ADD_NEW_DOCUMENT
  }
}

export const clearDocumentList = () => {
  return {
    type: types.CLEAR_DOCUMENT_LIST
  }
}

// export const updateDocumentCheckboxParams = ({ checked, id }) => {
//   return {
//     type: types.UPDATE_DOCUMENT_CHECKBOX_PARAMS,
//     payload: { checked, id }
//   }
// }

// export const getMemberDocumentMastersEnd = (documents) => {
//   return {
//     type: types.GET_MEMBER_DOCUMENT_MASTERS_END,
//     payload: documents
//   }
// }

export const getMemberDocumentListEnd = (documents) => {
  return {
    type: types.GET_MEMBER_DOCUMENT_LIST_END,
    payload: documents
  }
}

export const updateDocumentParamsEnd = (isMember, updatedDocParams) => {
  return {
    type: types.UPDATE_DOCUMENT_PARAMS_END,
    payload: { isMember, updatedDocParams }
  }
}

export const updateFileChangeEnd = (updatedFile) => {
  return {
    type: types.UPDATE_FILE_CHANGE_END,
    payload: { updatedFile }
  }
}

// export const updateHasCheckBoxInDocuments = (data) => {
//   return {
//     type: types.UPDATE_HAS_CHECKBOX_IN_DOCUMENTS,
//     data
//   }
// }

export const deleteDocumentFromGrid = () => {
  return {
    type: types.DELETE_DOCUMENT_FROM_GRID
  }
}

export const updateDocumentTableId = () => {
  return {
    type: types.UPDATE_DOCUMENTS_TABLE_ID
  }
}

// export const updateQuoteCustomerDocumentTableId = () => {
//   return {
//     type: types.UPDATE_QUOTE_CUSTOMER_DOCUMENTS_TABLE_ID
//   }
// }

export const getQuoteDocumentMastersEnd = (documents) => {
  return {
    type: types.GET_QUOTE_DOCUMENT_MASTERS_END,
    payload: documents
  }
}

export const setQuoteMembersResult = (result) => {
  return {
    type: types.SET_QUOTE_MEMBERS_RESULT,
    payload: result
  }
}
export const handleContinueEnd = (result) => {
  return {
    type: types.HANDLE_CONTINUE,
    payload: result
  }
}

export const setCurrentQuoteMember = (result) => {
  return {
    type: types.SET_CURRENT_QUOTE_MEMBER,
    payload: result
  }
}
export const setQuoteMemberForDocument = (result) => {
  return {
    type: types.SET_QUOTE_MEMBER_DOCUMENT,
    payload: result
  }
}

export const updateCurrentMemberInfoChange = ({ name, value }) => {
  return {
    type: types.UPDATE_CURRENT_MEMBER_INFO_CHANGE,
    payload: { name, value }
  }
}

export const setQuoteInformation = (result) => {
  return {
    type: types.SET_QUOTE_INFORMATION,
    payload: result
  }
}

export const setCurrentQuoteMembertoNull = (result) => {
  return {
    type: types.SET_CURRENT_QUOTE_MEMBER_TO_NULL
  }
}

export const updateDocumentParams = ({ id, name, value }) => {
  return function (dispatch, state) {
    let currentState = getState(state());
    let isMember = currentState.memberDocuments.isMemberDocument;
    let index = id;
    let fieldName = name;
    let fieldValue = value;
    try {
      dispatch(appActions.setLoading(true));
      if (isMember) {
        let updatedParam = {
          ...currentState.memberDocuments.documentList[index],
          [fieldName]: fieldValue
        }
        console.log(updatedParam)
        const spliceDocInfo = [...currentState.memberDocuments.documentList]
        spliceDocInfo.splice(id, 1)
        console.log(spliceDocInfo)
        spliceDocInfo.splice(id, 0, updatedParam);
        console.log(spliceDocInfo)
        dispatch(updateDocumentParamsEnd(isMember, spliceDocInfo))
      }
      else {
        let updatedParam = {
          ...currentState.quoteDocuments.documentList[index],
          [fieldName]: fieldValue
        }
        console.log(updatedParam)
        const spliceDocInfo = [...currentState.quoteDocuments.documentList]
        spliceDocInfo.splice(id, 1)
        console.log(spliceDocInfo)
        spliceDocInfo.splice(id, 0, updatedParam);
        console.log(spliceDocInfo)
        dispatch(updateDocumentParamsEnd(isMember, spliceDocInfo))
      }
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}

export const saveDocuments = (enquiryId) => {
  return async function (dispatch, state) {
    let currentState = getState(state());
    try {
      dispatch(appActions.setLoading(true));
      // let memberId = currentState.memberDocuments.isMemberDocument ? currentState.memberInformation.memberId : null;
      // let documents = currentState.memberDocuments.isMemberDocument ? currentState.memberDocuments.documentList : currentState.quoteDocuments.documentList;

      let memberId = currentState.quoteMembers.currentQuoteMember.memberId ?? currentState.quoteDocuments.memId;
      let activeStep = currentState.activeStep;
      let documents = currentState.quoteDocuments.documentList;
      // let documents = currentState.quoteDocuments.documentList.filter(doc => {
      //   return (
      //     doc.uploadedDate &&
      //     doc.fileInput && 
      //     doc.fileName
      //   );
      // });
      let saveDoc = {
        // "QuotationId": currentState.quoteInformation.quotationId,
        "QuotationId": 0,// currentState.basicInfoNewEnq.enquiryId == 0 ? enquiryId : currentState.basicInfoNewEnq.enquiryId,
        "EncryptedEnquiryRefId1": currentState.basicInfoNewEnq.encryptedEnquiryRefId1,
        "EncryptedEnquiryRefId2": currentState.basicInfoNewEnq.encryptedEnquiryRefId2,
        "MemberId": memberId,
        "Documents": documents,
        "ProductTypeId": appConstants.PRODUCT_TYPE_INDIVIDUAL,
        "IsMemberDocs": activeStep !== 4
      }
      let sr = await quotationService.saveMemberDocuments(saveDoc);
      console.log(sr);
      if (sr.hasErrors) {
        dispatch(appActions.showValidationErrors(sr));
        return false;
      }

      let dialogeData = {
        message: `Documents Successfully Saved!`,
        showConfirmPopup: true,
        isConfirm: false,
        isInfo: true,

      }

      await dispatch(toggleConfirmPopup(dialogeData));

      if (activeStep !== 4) {
        await dispatch(setQuoteMemberSavedTrue());
      }
      // dispatch(appActions.showMessage("!", { buttons: ['Ok'] }));
      return true;
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}

export const deleteDocument = () => {
  return async function (dispatch, state,) {
    let currentState = getState(state());
    try {
      let confirm = await dispatch(appActions.showMessage("Are you sure ? You want to delete the document?", { buttons: ['Yes', 'Close'] }));
      if (confirm === 'Close') {
        return false;
      }
      dispatch(appActions.setLoading(true));
      dispatch(deleteDocumentFromGrid());
      /*let isMember = currentState.memberDocuments.isMemberDocument;
      let memberId = currentState.memberDocuments.isMemberDocument ? currentState.memberInformation.memberId : null;
      let documentType = currentState.memberDocuments.isMemberDocument ? currentState.memberDocuments.documentList : currentState.quoteDocuments.documentList;
      let documents = documentType.filter(d => !d.isChecked);
      let saveDoc = {
        "QuotationId": currentState.quoteInformation.quotationId,
        "MemberId": memberId,
        "Documents": documents
      }
      let sr = await quotationService.saveMemberDocuments(saveDoc);
      console.log(sr);
      if (sr.hasErrors) {
        dispatch(appActions.showValidationErrors(sr));
        return false;
      }
      if (sr) {
        dispatch(appActions.showMessage("Document Successfully Deleted!", { buttons: ['Ok'] }));
        //to delete if else conditions if this code comes into play again
        if (isMember) {
          dispatch(getMemberDocumentList());
        }
        else {
          dispatch(getQuoteDocumentList());
        }
      }*/
      return true;
      /*let documents = isMember ? currentState.memberDocuments.documentList : currentState.quoteDocuments.documentList;
      let deleteMember = documents.filter(p => p.isChecked == true && p.docType != null);
      let memberId = isMember ? currentState.memberInformation.memberId : null;
      let documentToDelete = {
        "Documents": documents.filter(p => p.isChecked == true && p.docType != null),
        "MemberId": memberId,
        "QuotationId": currentState.quoteInformation.quotationId
      }
      let sr = await quotationService.deleteDocuments(documentToDelete);
      if (sr.hasErrors) {
        dispatch(appActions.showValidationErrors(sr));
        return false;
      }*/
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}

export const toggleConfirmPopup = (data) => {
  return (dispatch) => {
    return new Promise((resolve) => {
      dispatch({
        type: types.TOGGLE_CONFRIM_POPUP,
        payload: {
          ...data,
          resolve: resolve,  // resolve the promise when the user clicks Yes/No
        }
      });
    });
  };
};
export const confirmYes = () => ({
  type: types.CONFIRM_YES,
});

export const setProductId = (prodId) => ({
  type: types.SET_PRODUCT_ID,
  payload: prodId
});

export const confirmNo = () => ({
  type: types.CONFIRM_NO,
});

export const getMICustomerMasters = () => {
  return async function (dispatch, state) {
    try {
      dispatch(appActions.setLoading(true));
      let sr = await quotationService.getMICustomerMasters();
      if (sr.result) {
        dispatch(getMICustomerMastersEnd(sr.result));

      }
      if (sr.hasErrors) {
        dispatch(appActions.showValidationErrors(sr));
        return false;
      }
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}


export const toggleMafPopup = () => {
  return async function (dispatch, state) {
    try {
      dispatch(appActions.setLoading(true));


      let dialogeData = {
        message: `Please select at least one member under each MAF question!`,
        showConfirmPopup: true,
        isConfirm: false,
        isInfo: true,

      }
      await dispatch(toggleConfirmPopup(dialogeData));

    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}

export const saveMICustomerEnquiry = (data) => {
  return async function (dispatch, state) {
    try {
      dispatch(appActions.setLoading(true));
      let sr = await quotationService.saveNewEnquiry(data);
      if (sr.hasErrors) {
        dispatch(appActions.showValidationErrors(sr));
        return false;
      }
      if (sr.result) {
        dispatch(saveMICustomerNewEnqEnd(sr.result));
        dispatch(getQuoteMembers());

        let dialogeData = {
          message: `Successfully Saved Enquiry Number ${sr?.result?.enquiryNo}!`,
          showConfirmPopup: true,
          isConfirm: false,
          isInfo: true,

        }
        if (data?.isSponsorMember) {
          await dispatch(addSponserToQuote())
        }
        dispatch(toggleConfirmPopup(dialogeData));

        dispatch(updateBasicMemberInfo({ name: 'enquiryId', value: sr?.result?.enquiryId }))
        dispatch(updateBasicMemberInfo({ name: 'encryptedEnquiryRefId1', value: sr?.result?.encryptedEnquiryRefId1 }))
        dispatch(updateBasicMemberInfo({ name: 'encryptedEnquiryRefId2', value: sr?.result?.encryptedEnquiryRefId2 }))
        dispatch(updateBasicMemberInfo({ name: 'enquiryNo', value: sr?.result?.enquiryNo }))

        dispatch(handleNextStep(1))

        await dispatch(getfilteredNetworks(sr?.result));
        return true;
      }

    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}


export const saveProspectDetails = (data, enquiryId) => {
  return async function (dispatch, state) {
    try {
      dispatch(appActions.setLoading(true));
      let dataa = {
        ...data,
        'quotationId': enquiryId
      }
      let sr = await quotationService.saveProspectDetails(dataa);
      if (sr.hasErrors) {
        dispatch(appActions.showValidationErrors(sr));
        return false;
      }
      dispatch(getMembersByQuoteId())
      // if (sr.result) {
      //   dispatch(saveProspectDetailsEnd(sr.result));
      //   // dispatch(getQuoteMembers());

      let dialogeData = {
        message: `Successfully Saved Prospect Details!`,
        showConfirmPopup: true,
        isConfirm: false,
        isInfo: true,

      }
      // if (data?.isSponsorMember) {
      //   await dispatch(addSponserToQuote())
      // }
      await dispatch(toggleConfirmPopup(dialogeData));

      // dispatch(updateBasicMemberInfo({ name: 'enquiryId', value: sr?.result?.enquiryId }))
      // dispatch(updateBasicMemberInfo({ name: 'enquiryNo', value: sr?.result?.enquiryNo }))

      // dispatch(handleNextStep(1))
      //     }

    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}
export const validateSaveMICustomerMemberBasicInfo = (data, index = 1) => {
  return async function (dispatch, state) {
    try {
      let currentState = getState(state());
      console.log(data);

      dispatch(appActions.setLoading(true));
      var res1 = {
        "EnquiryId": 0,
        "EncryptedEnquiryRefId1": currentState.basicInfoNewEnq?.encryptedEnquiryRefId1,
        "EncryptedEnquiryRefId2": currentState.basicInfoNewEnq?.encryptedEnquiryRefId2,
        "EnquiryNo": currentState.basicInfoNewEnq?.enquiryNo,
        "VisaEmirate": currentState.basicInfoNewEnq.visaEmirate,
        "MemberList": currentState.memberBasicInfo.memberList,
      };

      let sr = await quotationService.validateSaveMemberBasicInfo(res1);
      if (sr.hasErrors) {
        dispatch(appActions.showValidationErrors(sr));
        return false;
      }

      return true;

    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}
export const saveMICustomerMemberBasicInfo = (data, index = 1) => {
  return async function (dispatch, state) {
    try {
      let currentState = getState(state());
      console.log(data);

      dispatch(appActions.setLoading(true));
      var res1 = {
        "EnquiryId": 0,
        "EncryptedEnquiryRefId1": currentState.basicInfoNewEnq?.encryptedEnquiryRefId1,
        "EncryptedEnquiryRefId2": currentState.basicInfoNewEnq?.encryptedEnquiryRefId2,
        "EnquiryNo": currentState.basicInfoNewEnq?.enquiryNo,
        "VisaEmirate": currentState.basicInfoNewEnq.visaEmirate,
        "MemberList": currentState.memberBasicInfo.memberList,
      };

      let sr = await quotationService.saveMemberBasicInfo(res1);
      if (sr.hasErrors) {
        dispatch(appActions.showValidationErrors(sr));
        return false;
      }
      if (sr.result) {
        await dispatch(saveMICustomeMemberBasicInfoEnd(sr.result));
        if (index == 2) {
          let srr = await quotationService.getQuoteInformation(currentState?.basicInfoNewEnq?.encryptedEnquiryRefId1, currentState.basicInfoNewEnq.encryptedEnquiryRefId2);
          await dispatch(setQuoteInformation(srr?.result));

          console.log('dwdsdadad', srr?.result?.isRefertoUW);
          if (!srr?.result?.isRefertoUW) {
            dispatch(handleNextStep(4))
          }
          else {
            let dialogeData = {
              message: 'Your Quotation is Referred. Our Team is reviewing your Quotation please make sure all members document upload, and final premuim will be shared',
              showConfirmPopup: true,
              isConfirm: false,
              isInfo: true,


            }
            await dispatch(toggleConfirmPopup(dialogeData));
          }
          return true;
        }
        return true;
      }

    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}
export const getQuoteMembers = (fromMaf = false) => {
  return async function (dispatch, state) {
    try {
      console.log('getQuoteMembers');

      let currentState = getState(state());
      let quoteId = currentState.basicInfoNewEnq.quoteId ?? currentState.basicInfoNewEnq.enquiryId;
      let encryptedEnquiryRefId1 = currentState.basicInfoNewEnq.encryptedEnquiryRefId1;
      let encryptedEnquiryRefId2 = currentState.basicInfoNewEnq.encryptedEnquiryRefId2;
      // let quoteId = currentState.basicInfoNewEnq.quoteId;
      dispatch(appActions.setLoading(true));
      let sr = await quotationService.getQuoteMembers(encryptedEnquiryRefId1, encryptedEnquiryRefId2);
      if (sr.hasErrors) {
        dispatch(appActions.showValidationErrors(sr));
        return false;
      }
      if (sr.result) {
        if (sr?.result.memberList.length == 0 && currentState.basicInfoNewEnq.isSponsorMember) {
          dispatch(addSponserToQuote());
        }
        if (sr?.result.memberList.length > 0) {
          dispatch(getQuoteMembersEnd(sr.result));
          if (fromMaf) {
            dispatch(updateBasicMemberInfo({ name: 'enquiryId', value: currentState?.basicInfoNewEnq?.enquiryId }))
            dispatch(updateBasicMemberInfo({ name: 'encryptedEnquiryRefId1', value: currentState?.basicInfoNewEnq?.encryptedEnquiryRefId1 }))
            dispatch(updateBasicMemberInfo({ name: 'encryptedEnquiryRefId2', value: currentState?.basicInfoNewEnq?.encryptedEnquiryRefId2 }))
            dispatch(updateBasicMemberInfo({ name: 'enquiryNo', value: currentState?.basicInfoNewEnq?.enquiryNo }))
          }

        }

      }

    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}

export const addMemberEnd = () => {

  return {
    type: types.ADD_MEMBER,

  }
}

export const addMember = () => {
  return async function (dispatch, state) {
    // try {
    let currentState = getState(state());
    let memberList = currentState.memberBasicInfo.memberList;

    // if (memberList?.length >= 5) {
    //   let dialogeData = {
    //     message: `Max 5 Members Allowed!!`,
    //     showConfirmPopup: true,
    //     isConfirm: false,
    //     isInfo: true,

    //   }
    //   await dispatch(toggleConfirmPopup(dialogeData));
    //   return;
    // }

    dispatch(addMemberEnd());

    // } catch (e) {
    //   dispatch(appActions.handleError(e));
    // } finally {
    //   dispatch(appActions.setLoading(false));
    // }
  }
}


export const deleteMember = (member) => {
  return async function (dispatch, state,) {

    try {
      let isPrincipal = member.relation == appConstants.RELATION_PRINCIPAL_ID;
      let message = isPrincipal ?
        "You are deleting a PRINCIPAL member. Doing so will delete all its dependents. Are you sure you want to delete?"
        : "Are you sure you want to delete the member?";
      let dialogeData = {
        message: message,
        showConfirmPopup: true,
        isConfirm: true,
        isInfo: false,

      }
      const userResponse = await dispatch(toggleConfirmPopup(dialogeData));
      if (userResponse == false) {
        return false
      }
      dispatch(appActions.setLoading(true));

      if (member?.memberId) {
        let sr = await quotationService.deleteMember(member?.memberId);
        if (sr.hasErrors) {
          dispatch(appActions.showValidationErrors(sr));
          return false;
        }
        dispatch(getQuoteMembers());
      }

      if (isPrincipal) {
        dispatch(deleteAllMembers())
      }
      else {
        dispatch(deleteMemberFromGrid(member.srlNo));
      }





      dispatch(appActions.setLoading(false));


    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}






















export const updateProductSelectionParams = ({ name, value }) => {
  return {
    type: types.UPDATE_PRODUCT_SELECTION_PARAMS,
    payload: { name, value }
  }
}

export const updateProductType = ({ name, value }) => {
  return {
    type: types.UPDATE_PRODUCT_TYPE,
    payload: { name, value }
  }
}
export const getPlanTypeByNetworkIdEnd = (netId) => {
  return {
    type: types.GET_PLAN_TYPE_BY_NETWORK_ID,
    payload: netId
  }
}

export const updatePlanTOBParams = ({ name, value }) => {
  return {
    type: types.UPDATE_PLAN_TOB_PARAMS,
    payload: { name, value }
  }
}
export const resetPlanTObParams = () => {
  return {
    type: types.RESET_PLAN_TOB_PARAMS
  }
}
export const resetProductSelection = () => {
  return {
    type: types.RESET_PRODUCT_SELECTION_PARAMS
  }
}
export const resetPlanSelection = () => {
  return {
    type: types.RESET_PLAN_SELECTION_PARAMS
  }
}

export const getBenefitStructureByPlanIdsEnd = (result) => {
  return {
    type: types.GET_PLAN_COMPARE_STRUCUTRE_END,
    result
  }
}
export const savePlanDetailsEnd = (result) => {
  return {
    type: types.SAVE_PLAN_DETAILS,
    payload: result
  }
}

export const updatePlanSelection = ({ checked, id, productId }) => {
  return {
    type: types.UPDATE_PLAN_SELECTION,
    payload: { checked, id, productId }
  }
}

export function getProductPlanByVisaEmirateIdForIndicativeQuote(visaEmirateId, netwrokId = 0) {
  return async function (dispatch, state) {
    try {
      dispatch(appActions.setLoading(true));
      let currentState = getState(state());

      let enquiryNo = currentState?.basicInfoNewEnq?.enquiryNo;
      let encryptedEnquiryRefId1 = currentState?.basicInfoNewEnq?.encryptedEnquiryRefId1;
      let encryptedEnquiryRefId2 = currentState?.basicInfoNewEnq?.encryptedEnquiryRefId2;
      // let enquiryNo = 'E/Q/000451';
      // let enquiryId = 54232;
      let result = await quotationService.getProductPlanByVisaEmirateIdForIndicativeQuote(visaEmirateId, enquiryNo, encryptedEnquiryRefId1, encryptedEnquiryRefId2, netwrokId ?? 0);
      if (result?.hasErrors) {
        dispatch(appActions.showValidationErrors(result));
        return false;
      }
      if (result) {
        dispatch(getProductPlanByVisaEmirateIdEnd(result?.result));
      }
      return true;
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}
export function validateSavePlanDetails(canSave) {
  return async function (dispatch, state) {
    try {


      let currentState = getState(state());
      let planSelectedCount = currentState?.productSelection?.plansList?.filter(x => x?.isChecked == true);
      let planSelected = currentState?.productSelection?.plansList?.find(x => x?.isChecked == true);
      if (!planSelected) {        
        return true;
      }
      if (planSelectedCount?.length != 1) {
        return true;
      }
      dispatch(appActions.setLoading(true));


      let saveDto = {
        // enquiryId: currentState?.basicInfoNewEnq?.enquiryId,
        encryptedEnquiryRefId1: currentState?.basicInfoNewEnq?.encryptedEnquiryRefId1,
        encryptedEnquiryRefId2: currentState?.basicInfoNewEnq?.encryptedEnquiryRefId2,
        // '54262',
        enquiryNo: currentState?.basicInfoNewEnq?.enquiryNo,
        //'E/Q/000477',
        planId: planSelected?.planId,
        planType: planSelected?.portalPlanTypeId,
        productPlanId: planSelected?.productPlanId,
      }

      if (canSave) {


        let result = await quotationService.validateSavePlanDetails(saveDto);
        if (result?.hasErrors) {
          dispatch(appActions.showValidationErrors(result));
          return false;
        }
      }
      
      return true;
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}
export function savePlanDetails(canSave) {
  return async function (dispatch, state) {
    try {


      let currentState = getState(state());
      let planSelectedCount = currentState?.productSelection?.plansList?.filter(x => x?.isChecked == true);
      let planSelected = currentState?.productSelection?.plansList?.find(x => x?.isChecked == true);
      if (!planSelected) {
        let dialogeData = {
          message: `Please select a Plan to Proceed`,
          showConfirmPopup: true,
          isConfirm: false,
          isInfo: true,

        }


        await dispatch(toggleConfirmPopup(dialogeData));
        return true;
      }
      if (planSelectedCount?.length != 1) {
        let dialogeData = {
          message: `Please select only one Plan  to Proceed `,
          showConfirmPopup: true,
          isConfirm: false,
          isInfo: true,

        }


        await dispatch(toggleConfirmPopup(dialogeData));
        return true;
      }
      dispatch(appActions.setLoading(true));


      let saveDto = {
        // enquiryId: currentState?.basicInfoNewEnq?.enquiryId,
        encryptedEnquiryRefId1: currentState?.basicInfoNewEnq?.encryptedEnquiryRefId1,
        encryptedEnquiryRefId2: currentState?.basicInfoNewEnq?.encryptedEnquiryRefId2,
        // '54262',
        enquiryNo: currentState?.basicInfoNewEnq?.enquiryNo,
        //'E/Q/000477',
        planId: planSelected?.planId,
        planType: planSelected?.portalPlanTypeId,
        productPlanId: planSelected?.productPlanId,
      }

      if (canSave) {

        var validated = await dispatch(validateSavePlanDetails(saveDto));
        if (!validated) {
          return false;
        }
        let result = await quotationService.savePlanDetails(saveDto);
        if (result) {
          dispatch(savePlanDetailsEnd(result));
          let message = `Successfully Saved Quote Number ${result?.result?.quoteNumber}!`;
          let dialogeData = {
            message: message,
            showConfirmPopup: true,
            isConfirm: false,
            isInfo: true,
          }
          await dispatch(toggleConfirmPopup(dialogeData));
        }
      }
      await dispatch(setProductId(planSelected?.productId));
      if (planSelected?.productId == appConstants.NE_BASIC_ESS_PRODUCT_ID || planSelected?.productId == appConstants.NE_BASIC_PRODUCT_ID) {
        await dispatch(handleNextStep(4))
      }
      else {

        await dispatch(handleNextStep(3))
      }
      return true;
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}

export function getMembersBasePremiumByPlan(planId, productId) {
  return async function (dispatch, state) {
    try {
      dispatch(appActions.setLoading(true));
      let currentState = getState(state());

      // let enquiryNo = currentState?.basicInfoNewEnq?.enquiryNo;
      let enquiryNo = currentState?.basicInfoNewEnq?.enquiryNo;
      let enquiryId = currentState?.basicInfoNewEnq?.enquiryId;

      // let enquiryNo = 'E/Q/000451';
      // let enquiryId = 54232;
      let result = await quotationService.getMembersBasePremiumByPlan(planId, productId, enquiryId);
      if (result) {
        await dispatch(getMemberBasePremuimEnd(result));
        await dispatch(toggleBasePremModel(true));
        await dispatch(togglePlanTOBModel(false));
        await dispatch(togglePlanCompare(false));
      }
      return true;
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}
export const getProductPlanByVisaEmirateIdEnd = (result) => {
  return {
    type: types.GET_PLANS_BY_VISA_EMIRATES_END,
    result
  }
}
export const getMemberBasePremuimEnd = (result) => {
  return {
    type: types.GET_MEMBER_BASE_PLAN_END,
    result
  }
}
export function getProductPlanByVisaEmirateId(networkId = 0) {
  return async function (dispatch, state) {
    try {
      dispatch(appActions.setLoading(true));
      let currentState = getState(state());
      let result = await quotationService.getProductsByVisaEmirateId(currentState.productSelection.visaEmirate, networkId);
      if (result) {
        dispatch(getProductPlanByVisaEmirateIdEnd(result));
      }
      return true;
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}
export const getMembersBasePremiumByPlanEnd = (result) => {
  return {
    type: types.GET_BASE_PREMIUM_BY_PLAN_END,
    result
  }
}

export const saveIndicativeQuote = (section) => {
  return async function (dispatch, state,) {
    let currentState = getState(state());
    // let currentMibrokerState = getMiBrokerState(state());
    try {
      // let masters=await dispatch(miBrokerActions.getInsuredInfoMasters(0));
      // let indicativeQuote = currentState.indicativeQuote;
      // let planList = currentState.productSelection.plansList.filter(p => p.isChecked == true);
      // let planListToPrint = currentState.productSelection.plansList.filter(p => p.portalPlanTypeId == currentState.productSelection.planType);
      // if (planList.length != 1) {
      //   let confirm = await dispatch(appActions.showMessage(planList.length == 0 ?
      //     "Please select a Plan" : "Select only one plan"
      //     , { buttons: ['Close'] }));
      //   if (confirm === 'Close') {
      //     return false;
      //   }
      // }
      // console.log(indicativeQuote);
      // let param = {
      //   "VisaEmirate": indicativeQuote.insuredInfo.visaEmirate,
      //   "VisaType": indicativeQuote.insuredInfo.visaType,
      //   "PlanType": planList[0].portalPlanTypeId,
      //   "FirstName": indicativeQuote.insuredInfo.firstName,
      //   "MiddleName": indicativeQuote.insuredInfo.middleName,
      //   "LastName": indicativeQuote.insuredInfo.lastName,
      //   "DateOfBirth": indicativeQuote.insuredInfo.dateOfBirth,
      //   "Gender": indicativeQuote.insuredInfo.gender,
      //   "MaritalStatus": indicativeQuote.insuredInfo.maritalStatus,
      //   "Mobile": indicativeQuote.insuredInfo.mobile,
      //   "Email": indicativeQuote.insuredInfo.email,
      //   "Plan": planList[0].planId,
      //   "SingleMemberPolicyYN": indicativeQuote.insuredInfo.singleMemberPolicyYN,
      //   "MemberList": indicativeQuote.memberList,
      //   "Masters":masters,
      //   "PlansListToPrint":planListToPrint
      // };
      // dispatch(appActions.setLoading(true));
      // let sr = await quotationService.saveIndicativeQuote(param);
      // if (sr.hasErrors) {
      //   dispatch(appActions.showValidationErrors(sr));
      //   return false;
      // }
      // dispatch(appActions.showMessage("Indicative Quote successfully saved!", { buttons: ['Ok'] }));
      // return sr.result.quotationId; //enquiry number
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}
export function getBenefitStructureByPlanIds(sourceType) {
  return async function (dispatch, state) {
    try {
      let currentState = getState(state());
      let planIds = [];
      var ids = [];
      if (sourceType == "PlanSelection") {
        planIds = currentState.planSelection.plansList.filter(p => p.isChecked == true);
        ids = planIds.map(a => a.planId);
        console.log("testtttt11111", ids)
        //  alert("PlanSelection")
      } else {
        planIds = currentState.productSelection.plansList.filter(p => p.isChecked == true);
        ids = planIds.map(a => a.planId);
        console.log("testtttt", ids)
        // alert("other")
      }

      if (ids.length < 1) {
        // let confirm = await dispatch(appActions.showMessage(
        //   "Please select plans to compare", { buttons: ['Close'] }));
        // if (confirm === 'Close') {
        //   return false;
        // }


        let message = `Please select plans to compare!`;
        let dialogeData = {
          message: message,
          showConfirmPopup: true,
          isConfirm: false,
          isInfo: true,

        }
        await dispatch(toggleConfirmPopup(dialogeData));
        return false;
      }
      let params = {
        "PlanIds": ids,
        "EncryptedEnquiryRefId1": currentState?.basicInfoNewEnq?.encryptedEnquiryRefId1,
        "EncryptedEnquiryRefId2": currentState?.basicInfoNewEnq?.encryptedEnquiryRefId2,

      }

      console.log(ids);
      dispatch(appActions.setLoading(true));
      let result = await quotationService.getBenefitStructureByPlanIds(params);
      if (result) {
        dispatch(getBenefitStructureByPlanIdsEnd(result));
        dispatch(togglePlanCompare(true));
        await dispatch(toggleBasePremModel(false));
        await dispatch(togglePlanTOBModel(false));
      }
      let currentState1 = getState(state());
      console.log("currentState1.benefitStructure", currentState1.benefitStructure);
      return true;
    } catch (e) {
      //  dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}
export const updateIndicativeQuoteParams = ({ name, value }) => {
  return {
    type: types.UPDATE_INDICATIVE_QUOTE_PARAMS,
    payload: { name, value }
  }
}
export const uncheckAllSelctedPlanInProductSelecction = () => {
  return {
    type: types.CLEAR_PRODUCT_SELECTION_PLANS_CHECKBOXES,
  }
}
export const getProductPlanTOBByPlanIdEnd = (result) => {
  return {
    type: types.GET_INDIVIDUAL_PLANS_TOB_END,
    result
  }
}
export function getProductPlanTOBByPlanId(planId) {
  return async function (dispatch, state) {
    // let currentState = getState(state());
    try {
      dispatch(appActions.setLoading(true));
      let result = await quotationService.getProductPlanTOBByPlanId(planId);

      if (result) {
        await dispatch(getProductPlanTOBByPlanIdEnd(result));
        await dispatch(togglePlanTOBModel(true));
        await dispatch(toggleBasePremModel(false));
      }
      return true;
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}

export const updateProductSelectionCheckboxParams = (checked, planId) => {
  return {
    type: types.UPDATE_PRODUCT_SELECTION_CHECKBOX_CHANGE_PARAMS,
    payload: { checked, planId }
  }
}




export function getMafQuestions() {
  return async function (dispatch, state) {
    let currentState = getState(state());
    try {
      dispatch(appActions.setLoading(true));
      let sr = await quotationService.getMafQuestions(currentState?.basicInfoNewEnq?.selectedPlan?.productId ?? currentState?.basicInfoNewEnq?.planId);
      if (sr.result) {
        dispatch(getMafQuestionsEnd(sr.result));
      }
      if (sr.hasErrors) {
        dispatch(appActions.showValidationErrors(sr));
        return false;
      }
      return true;
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}
export const getMafQuestionsEnd = (result) => {
  return {
    type: types.GET_MAF_QUESTIONS_END,
    payload: result
  }
}
export const updateMedicalFormParams = ({ name, value }) => {
  return {
    type: types.UPDATE_MEDICAL_FORM_PARAMS,
    payload: { name, value }
  }
}
export const updateSubMedicalFormParams = ({ name, value }) => {
  return {
    type: types.UPDATE_SUB_MEDICAL_FORM_PARAMS,
    payload: { name, value }
  }
}
export const updateMedicalFormRemarks = ({ id, value }) => {
  return {
    type: types.UPDATE_MEDICAL_FORM_REMARKS,
    payload: { id, value }
  }
}
export const updateMedicalFormRemarksDate = ({ id, value }) => {
  return {
    type: types.UPDATE_MEDICAL_FORM_REMARKS_DATE,
    payload: { id, value }
  }
}
export const updateMedicalFormList = ({ id, value, itemId }) => {
  return {
    type: types.UPDATE_MEDICAL_FORM_LIST,
    payload: { id, value, itemId }
  }
}
export const updateMAFInfo = ({ name, value }) => {
  return {
    type: types.UPDATE_MAF_INFO,
    payload: { name, value }
  }
}

export const saveMedicalFormDetails = () => {
  return async function (dispatch, state) {
    let currentState = getState(state());
    let checkShortQ = currentState.medicalApplicationForm.mafQuestions.filter(p => p.isApplicable == "Y" && p.sectionId == "1");
    // let checkFullQ = currentState.medicalApplicationForm.mafQuestions.filter(p => p.isApplicable != null && p.sectionId == "2");
    await dispatch(checkShortQuestionsMafStatus(checkShortQ, currentState.medicalApplicationForm.currentMemberId));
    var tempObj = await dispatch(checkShortQuestionsMafStatusAlt(checkShortQ, currentState.medicalApplicationForm.currentMemberId));

    try {
      dispatch(appActions.setLoading(true));
      let memberList = [...currentState?.memberBasicInfo?.memberList];
      let questions = [...currentState?.medicalApplicationForm?.mafQuestionsOriginal];//mafQuestions;
      // let quotationId = currentState?.basicInfoNewEnq?.enquiryId;
      let encryptedEnquiryRefId1 = currentState?.basicInfoNewEnq?.encryptedEnquiryRefId1;
      let encryptedEnquiryRefId2 = currentState?.basicInfoNewEnq?.encryptedEnquiryRefId2;
      let referral = tempObj?.medicalApplicationFormReferralStatus?.referralStatus;//currentState?.medicalApplicationForm?.referralStatus;
      let mafStatus = tempObj?.medicalApplicationFormReferralStatus?.mafStatus;//currentState?.medicalApplicationForm?.mafStatus;
      let selectedPlan = currentState?.basicInfoNewEnq?.selectedPlan;
      console.log();

      let saveQuoteInfo2 = memberList?.map((x) => {
        return {
          Questions: questions,
          MemberId: x?.memberId,
          // QuotationId: quotationId,
          EncryptedEnquiryRefId1: encryptedEnquiryRefId1,
          EncryptedEnquiryRefId2: encryptedEnquiryRefId2,
          Referral: referral?.find(z => z?.memberId == x?.memberId)?.MemberReferral,
          MafStatus: mafStatus?.find(z => z?.memberId == x?.memberId)?.mafMemberStatus,
          CheckShortQStatus: true, // checkShortQStatus,
          PlanId: selectedPlan?.planId ?? currentState?.basicInfoNewEnq?.planId, // plan,
          ProductId: selectedPlan?.productId ?? currentState?.basicInfoNewEnq?.productId, // product,
        };
      });
      console.log("Brinjal", saveQuoteInfo2)

      currentState?.medicalApplicationForm?.mafAnswers?.filter(notEmpt => notEmpt?.memberIdList?.length > 0)?.forEach(x => {
        x?.memberIdList?.forEach(mem => {
          var affectedRecord = saveQuoteInfo2?.find(y => y?.MemberId == mem);
          var affectedQuestion = { ...affectedRecord?.Questions?.find(z => z?.itemId == x?.itemId) }
          affectedQuestion.isApplicable = "Y"
          var affectedQuestionIndex = affectedRecord?.Questions?.findIndex(z => z?.itemId == x?.itemId)
          var newQuestions = [...affectedRecord?.Questions?.slice(0, affectedQuestionIndex), affectedQuestion, ...affectedRecord?.Questions?.slice(affectedQuestionIndex + 1, affectedRecord?.Questions?.length)]
          affectedRecord.Questions = newQuestions;

        })
      });
      console.log("Brinjal x2", saveQuoteInfo2)

      // saveQuoteInfo2?.forEach(x => {
      //   var lmpDateQuestion = { ...x?.Questions[constants.MAF_ITEM_ID_59 - 1] }
      //   lmpDateQuestion.value = currentState?.medicalApplicationForm?.mafDateAnswers?.find(y => y?.memberId == x?.MemberId)?.date
      //   lmpDateQuestion.isApplicable = (currentState?.medicalApplicationForm?.mafDateAnswers?.find(y => y?.memberId == x?.MemberId)?.date != null) ? "Y" : null
      //   x.Questions = [...x?.Questions?.slice(0, (constants.MAF_ITEM_ID_59 - 1)), lmpDateQuestion, ...x?.Questions?.slice((constants.MAF_ITEM_ID_59), x?.Questions?.length)]

      // }
      // )

      const updatedSaveQuoteInfo2 = saveQuoteInfo2.map(member => {
        // Find the date answer for this member
        const dateValue = currentState?.medicalApplicationForm?.mafDateAnswers
          ?.find(y => y?.memberId === member.MemberId)?.date;

        // Map questions and update itemId 59 if present
        const updatedQuestions = member.Questions.map(q => {
          if (q.itemId === constants.MAF_ITEM_ID_59) {
            return {
              ...q,
              value: dateValue,
              isApplicable: dateValue ? "Y" : null
            };
          }
          return q;
        });

        // Return a new member object with updated questions
        return {
          ...member,
          Questions: updatedQuestions
        };
      });

      console.log("Brinjal x3", updatedSaveQuoteInfo2)

      let sr = await quotationService.saveMedicalFormDetails(updatedSaveQuoteInfo2);
      console.log(sr);
      if (sr.hasErrors) {
        dispatch(appActions.showValidationErrors(sr));
        return false;
      }
      let message = `Successfully Saved!`;
      let dialogeData = {
        message: message,
        showConfirmPopup: true,
        isConfirm: false,
        isInfo: true,
        isComp: false,

      }
      //   await dispatch(toggleConfirmPopup(dialogeData));
      // await dispatch(getQuoteInformation(currentState?.basicInfoNewEnq?.enquiryId))
      return true;
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  };
};
export const checkShortQuestionsMafStatus = (data, memberId) => {
  return {
    type: types.CHECK_SHORT_QUESTIONS_MAF_STATUS_MICUSTOMER,
    payload: { data, memberId }
  }
}
export const checkShortQuestionsMafStatusAlt = (data, memberId) => {
  return async function (dispatch, state) {
    let currentState = getState(state());
    let ShortQuestionsCheckedYes = data.length == 0 ? false : true
    let memberList = currentState?.memberBasicInfo?.memberList
    let mafAnswers = currentState?.medicalApplicationForm?.mafAnswers
    var referralStatus = []
    var mafStatus = []
    memberList.forEach(member => {
      var refcheck = mafAnswers?.find(x => x?.memberIdList?.includes(member?.memberId))

      let MemberReferral = (/* data.length == 0 ||  */(refcheck == null)) ? "Clean" : "Referral"
      if (/* isRefferalMember[0].isMemberRefferal ||  */member?.bmi >= 36) {
        MemberReferral = "Referral"
      }
      let mafMemberStatus = MemberReferral == "Clean" ? "Complete" : "Incomplete"
      if (currentState?.basicInfoNewEnq?.selectedPlan?.productId == constants.PRODUCT_ASASI_EMPLOYEE && MemberReferral == "Referral" /* && state.medicalApplicationForm.mafQuestions.filter((e) => e.sectionId === constants.MAF_FULL_QUESTIONAIRE_ID && e.isSubItem === constants.MAF_IS_SUB_ITEM_FLAG_N) == 0 */) {
        mafMemberStatus = "Complete"
      }
      if (mafMemberStatus == "Incomplete") {
        ShortQuestionsCheckedYes = true;
      }
      referralStatus.push({ memberId: member?.memberId, MemberReferral }); //MemberReferral
      mafStatus.push({ memberId: member?.memberId, mafMemberStatus }); //mafMemberStatus
    }
    )
    return {
      medicalApplicationFormReferralStatus: {
        referralStatus: referralStatus,
        mafStatus: mafStatus
      }
    }
  };
}

export const updatePaymentTransactionsParams = ({ name, value }) => {

  return {
    type: types.UPDATE_PAYMENT_TRANSACTION_PARAMS,
    payload: { name, value }
  }
}
export const showTermsCondPopup = () => {
  return {
    type: types.SHOW_TERMS_COND_POPUP,

  }
}
export const showQuoteDocumentTab = () => {
  return {
    type: types.SHOW_QUOTE_DOCUMENT_TAB,

  }
}
export const showMemberDocumentTab = (memId) => {
  return {
    type: types.SHOW_MEMBER_DOCUMENT_TAB,
    payload: memId,

  }
}
export const showTermsAndComdPopap = ({ name, value, message }) => {
  return async function (dispatch, state) {
    try {

      // let confirm = await dispatch(appActions.showMessage(message,
      //   { buttons: ['Yes', 'Close'] }));
      // if (confirm === 'Close') {
      //   let name = "termsCond";
      //   let value = false;
      // }
      // await dispatch(actions.updatePaymentTransactionsParams({ name, value }));

      let dialogeData = {
        message: message,
        showConfirmPopup: true,
        isConfirm: true,
        isInfo: false,
        isComp: true,
        title: 'Terms & Condition'
      }

      const userResponse = await dispatch(toggleConfirmPopup(dialogeData));
      var resp = await dispatch(saveTermsAndConditionsResponse(userResponse))
      if (resp == true) {
        await dispatch(updatePaymentTransactionsParams({ name: 'termsCond', value: userResponse }));
      }
      else {
        return false
      }

      if (userResponse == true && resp == true) {
        return true
      }
      else {
        return false
      }




    }

    catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}
export const onProceedToPay = () => {
  return async function (dispatch, state) {
    let currentState = getState(state());

    if (!currentState?.payment?.termsCond) {
      let dialogeData = {
        message: `Please Approve Terms & Condition!`,
        showConfirmPopup: true,
        isConfirm: false,
        isInfo: true,
      }

      await dispatch(toggleConfirmPopup(dialogeData));
      return true;
    }
    try {
      dispatch(appActions.setLoading(true));
      let params = {
        // "ReferenceId": currentState?.basicInfoNewEnq?.enquiryId,
        "EncryptedEnquiryRefId1": currentState?.basicInfoNewEnq?.encryptedEnquiryRefId1,
        "EncryptedEnquiryRefId2": currentState?.basicInfoNewEnq?.encryptedEnquiryRefId2,
        "CreatePaymentLink": true,
        "CreatePaymentTran": true,
        "SendPaymentLinkEmail": true,
      }
      let sr = await quotationService.createOnlinePayment(params).then((resp) => {
        if (resp.hasErrors) {
          dispatch(appActions.showValidationErrors(resp));
          return false;
        }
        // {
        //   let name = "customerEmail";
        //   let value = resp.result.customerEmail;
        //   //      dispatch(updateEmailParams({ name, value }));
        // }
        // {
        //   let name = "referenceId";
        //   let value = currentState.quoteInformation.quotationId;
        //   //    dispatch(updateEmailParams({ name, value }));
        // }/*
        // {
        //   let name = "referenceNo";
        //   let value = currentState.quoteInformation.quotationNo;
        //   dispatch(updateEmailParams({ name, value }));
        // } */
        // {
        //   let name = "paymentLink";
        //   let value = resp.result.url;
        //   //    dispatch(updateEmailParams({ name, value }));
        // }
        // {
        //   let name = "paymentLinkRowVersion";
        //   let value = resp.result.paymentLinkRowVersion;
        //   //    dispatch(updateEmailParams({ name, value }));
        // }
        window.location.href = resp.result.url;
        /* 
        {
          let name = "rowVersion";
          let value = resp.result.rowVersion;
          dispatch(updateEmailParams({ name, value }));
        } */
        return true;
      });
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}
export const getPaymentInformationEnd = (result) => {
  return {
    type: types.GET_PAYMENT_INFORMATION_END_MICUSTOMER,
    payload: result
  }
}
export const toggleSearch = (result) => {
  console.log('toggleSearch', result);

  return {
    type: types.TOGGLE_SEARCH,
    payload: result
  }
}
export const getPaymentInformationByEncryptedReferenceId = (referenceId) => {
  return async function (dispatch, state) {
    let currentState = getState(state());
    try {
      dispatch(appActions.setLoading(true));
      let sr = await quotationService.getPaymentInformationByEncryptedReferenceId(referenceId).then((resp) => {
        if (resp.hasErrors) {
          dispatch(appActions.showValidationErrors(resp));
          return false;
        }
        dispatch(getPaymentInformationEnd(resp.result));
        return true;
      });
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}


export const getQuoteSearchResult = (payload) => {
  return async function (dispatch, state) {
    let currentState = getState(state());
    try {
      dispatch(appActions.setLoading(true));
      let sr = await quotationService.getQuoteSearchResult(payload).then((resp) => {
        if (resp.hasErrors) {
          dispatch(appActions.showValidationErrors(resp));
          return false;
        }
        dispatch(getQuoteSearchResultEnd(resp.result));
        return true;
      });
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}

export function getKYCReport(reportContext) {
  return async function (dispatch, state) {
    try {
      dispatch(appActions.setLoading(true));

      quotationService.getReportUrl(reportContext).then((resp) => {

        appUtilityFunction.openUrl(
          sharedGlobals.appUrls.reportManagerApiUrl +
          `api/ReportEngineService/GenerateReportInternal?apiKey=${constants.REPMANAGER_APIKEY}` +
          "&reportId=" +
          reportContext.ReportId +
          "&param=" +
          resp
        );

        // quotationService.getReportUrl(reportContext).then((resp) => {
        //   appUtilityFunction.openUrl(
        //     sharedGlobals.appUrls.reportManagerApiUrl +
        //       "api/ReportEngineService/GenerateReport?reportId=" +
        //       reportId +
        //       "&param=" +
        //       resp
        //   );
        //   // dispatch(getReportUrlEnd(resp));
      });
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  };
}

// export const getQuoteDocumentList = () => {
//   return async function (dispatch, state) {
//     let currentState = getState(state());
//     try {
//       dispatch(appActions.setLoading(true));
//       let params = {
//         "QuotationId": currentState.quoteInformation.quotationId,
//         "Product": currentState.quoteInformation.product,
//         "Stage": currentState.quoteInformation.stage
//       }
//       let resp = await quotationService.getQuoteDocumentList(params);
//       if (resp.hasErrors) {
//         dispatch(appActions.showValidationErrors(resp));
//         return false;
//       }
//       if (resp.result != null) {
//         // console.log(resp.result);
//         // resp.result.forEach(d => d.uploadedDate = d.uploadedDate == null ? null : d.uploadedDate);
//         // await dispatch(getQuoteDocumentListEnd(resp.result));
//       }
//       return true;
//     } catch (e) {
//       dispatch(appActions.handleError(e));
//     } finally {
//       dispatch(appActions.setLoading(false));
//     }
//   };
// }

export const getQuoteDocumentMasters = (memId = 0, enquiryId = 0) => {
  return async function (dispatch, state) {
    let currentState = getState(state());
    try {
      dispatch(appActions.setLoading(true));
      console.log('wewew', currentState.basicInfoNewEnq.enquiryId);

      let params = memId == 0 ? {
        "QuotationId": 0,//currentState.basicInfoNewEnq.enquiryId != 0 ? currentState.basicInfoNewEnq.enquiryId : enquiryId,
        "EncryptedEnquiryRefId1": currentState.basicInfoNewEnq.encryptedEnquiryRefId1,
        "EncryptedEnquiryRefId2": currentState.basicInfoNewEnq.encryptedEnquiryRefId2,
        "Product": currentState.basicInfoNewEnq.selectedPlan.productId
        // "Stage": currentState.basicInfoNewEnq.stage
      } : {
        "QuotationId": 0,//currentState.basicInfoNewEnq.enquiryId != 0 ? currentState.basicInfoNewEnq.enquiryId : enquiryId,
        "EncryptedEnquiryRefId1": currentState.basicInfoNewEnq.encryptedEnquiryRefId1,
        "EncryptedEnquiryRefId2": currentState.basicInfoNewEnq.encryptedEnquiryRefId2,
        "memberId": memId,
        "Product": currentState.basicInfoNewEnq.selectedPlan.productId
        // "Stage": currentState.basicInfoNewEnq.stage
      }
      let sr = await quotationService.getQuotationDocumentMasters(params);
      if (sr.hasErrors) {
        dispatch(appActions.showValidationErrors(sr));
        return false;
      }
      if (sr) {
        await dispatch(getQuoteDocumentMastersEnd(sr));
        await dispatch(updateDocumentTableId());
      }
      return true;
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}

export const updateFileChange = ({ id, field, name, docIdEncrypted, type, date }) => {
  return function (dispatch, state) {
    let currentState = getState(state());
    // let isMember = currentState.memberDocuments.isMemberDocument;
    let index = id;
    let fieldName = field;
    let fieldValue = docIdEncrypted;
    let fileName = name;
    let fileType = type;
    let uploadedDate = date;
    try {
      dispatch(appActions.setLoading(true));

      let updatedFile = {
        ...currentState.quoteDocuments.documentList[index],
        [fieldName]: fieldValue,
        fileName: fileName,
        fileType: fileType,
        uploadedDate: uploadedDate
      }

      dispatch(updateFileChangeEnd(updatedFile))
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}


export const getMembersByQuoteId = (quoteIdd = null) => {

  return async function (dispatch, state) {
    let currentState = getState(state());
    try {
      dispatch(appActions.setLoading(true));
      const restoredState = JSON.parse(localStorage.getItem("myAppState"));
      console.log('restoredState', restoredState);

      if (restoredState) {
        await dispatch(restoreStateAfterRedierct(restoredState))
      }
      let quoteId = quoteIdd != null ? quoteIdd : (currentState.basicInfoNewEnq.enquiryId ?? restoredState?.basicInfoNewEnq?.enquiryId);
      let encryptedEnquiryRefId1 = currentState.basicInfoNewEnq.encryptedEnquiryRefId1 ?? restoredState?.basicInfoNewEnq?.encryptedEnquiryRefId1;
      let encryptedEnquiryRefId2 = currentState.basicInfoNewEnq.encryptedEnquiryRefId2 ?? restoredState?.basicInfoNewEnq?.encryptedEnquiryRefId2;
      if (quoteId || encryptedEnquiryRefId1 || encryptedEnquiryRefId2) {
        let sr = await quotationService.getMembersByQuoteId(/* quoteId */{ encryptedEnquiryRefId1, encryptedEnquiryRefId2 });
        if (sr.hasErrors) {
          dispatch(appActions.showValidationErrors(sr));
          return false;
        }
        if (sr) {
          await dispatch(getQuoteMemberDetailsResultEnd(sr.result));
          await dispatch(setQuoteMembersResult(sr.result.memberList));
        }
      }

      return true;
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}


export const handleContinue = (data) => {
  return async function (dispatch, state) {
    try {
      let currentState = getState(state());
      let quoteId = currentState.paymentInformation.referenceId
      dispatch(appActions.setLoading(true));

      await dispatch(handleContinueEnd(quoteId));

    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}
export const validateUpdateQuoteMember = (data) => {
  return async function (dispatch, state) {
    try {
      dispatch(appActions.setLoading(true));
      let sr = await quotationService.validateUpdateQuoteMember(data);
      if (sr.hasErrors) {
        dispatch(appActions.showValidationErrors(sr));
        return false;
      }
      return true;
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}
export const updateQuoteMember = (data) => {
  return async function (dispatch, state) {
    try {
      dispatch(appActions.setLoading(true));
      let sr = await quotationService.updateQuoteMember(data);
      if (sr.hasErrors) {
        dispatch(appActions.showValidationErrors(sr));
        return false;
      }
      else {
        let dialogeData = {
          message: `Member Information Saved Successfully!`,
          showConfirmPopup: true,
          isConfirm: false,
          isInfo: true,

        }
        await dispatch(toggleConfirmPopup(dialogeData));
      }
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}

export const getQuoteInformation = (data, fromMain = false, quote = null) => {
  return async function (dispatch, state) {
    try {
      dispatch(appActions.setLoading(true));
      let sr = await quotationService.getQuoteInformation(data?.encryptedEnquiryRefId1, data?.encryptedEnquiryRefId2);
      if (sr.hasErrors) {
        dispatch(appActions.showValidationErrors(sr));
        return false;
      }
      else {
        await dispatch(setQuoteInformation(sr?.result));
        if (fromMain && quote) {
          if (sr?.result?.mafIsCompleted) {
            dispatch(handleNextStep(4))
          }
          else {
            dispatch(handleNextStep(3))
          }
        }

      }
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}

export const getQuoteDocuments = (memId = 0, quoteId = 0) => {
  return async function (dispatch, state) {
    let currentState = getState(state());
    try {
      const restoredState = JSON.parse(localStorage.getItem("myAppState"));
      dispatch(appActions.setLoading(true));
      let params = memId == 0 ? {
        "QuotationId": 0,// currentState.basicInfoNewEnq.quoteId ?? currentState.basicInfoNewEnq.enquiryId ?? quoteId,
        "Product": currentState.basicInfoNewEnq.selectedPlan.productId,
        "encryptedEnquiryRefId1": currentState.basicInfoNewEnq.encryptedEnquiryRefId1 ?? restoredState?.basicInfoNewEnq?.encryptedEnquiryRefId1,
        "encryptedEnquiryRefId2": currentState.basicInfoNewEnq.encryptedEnquiryRefId2 ?? restoredState?.basicInfoNewEnq?.encryptedEnquiryRefId2
        // "Stage": currentState.basicInfoNewEnq.stage
      } : {
        "QuotationId": 0,//currentState.basicInfoNewEnq.quoteId ?? currentState.basicInfoNewEnq.enquiryId ?? quoteId,
        "memberId": memId,
        "Product": currentState.basicInfoNewEnq.selectedPlan.productId,
        "encryptedEnquiryRefId1": currentState.basicInfoNewEnq.encryptedEnquiryRefId1 ?? restoredState?.basicInfoNewEnq?.encryptedEnquiryRefId1,
        "encryptedEnquiryRefId2": currentState.basicInfoNewEnq.encryptedEnquiryRefId2 ?? restoredState?.basicInfoNewEnq?.encryptedEnquiryRefId2
        // "Stage": currentState.basicInfoNewEnq.stage
      }
      let sr = await quotationService.getQuoteDocuments(params);
      if (sr.hasErrors) {
        dispatch(appActions.showValidationErrors(sr));
        return false;
      }
      if (sr?.result) {
        for (const obj of sr.result) {
          await dispatch(updateFileChangeEnd(obj));
        }
      }
      return true;
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}


export const getPremiumSummaryEnd = (result) => {
  return {
    type: types.GET_PREMIUM_SUMMARY_END,
    result
  }
}
export function getPremiumSummary() {
  return async function (dispatch, state) {
    let currentState = getState(state());
    try {
      dispatch(appActions.setLoading(true));

      // let quotationId = currentState.basicInfoNewEnq.enquiryId;
      let encryptedEnquiryRefId1 = currentState.basicInfoNewEnq.encryptedEnquiryRefId1;
      let encryptedEnquiryRefId2 = currentState.basicInfoNewEnq.encryptedEnquiryRefId2;
      let sr = await quotationService.getPremiumSummary(encryptedEnquiryRefId1, encryptedEnquiryRefId2);
      if (sr.hasErrors) {
        dispatch(appActions.showValidationErrors(sr));
        return false;
      }
      if (sr?.result) {
        dispatch(getPremiumSummaryEnd(sr?.result));
      }
      return true;
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}


export function getMafAnswers() {
  return async function (dispatch, state) {
    let currentState = getState(state());
    try {
      dispatch(appActions.setLoading(true));
      let sr = await quotationService.getMafAnswers(currentState?.basicInfoNewEnq?.encryptedEnquiryRefId1, currentState?.basicInfoNewEnq?.encryptedEnquiryRefId2);
      if (sr.result) {
        dispatch(getMafAnswersEnd(sr.result));
      }
      // if (sr.hasErrors) {
      //   dispatch(appActions.showValidationErrors(sr));
      //   return false;
      // }
      return true;
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}

export function showFinalPopup() {
  return async function (dispatch, state) {
    let currentState = getState(state());
    try {
      dispatch(appActions.setLoading(true));

      let encryptedEnquiryRefId1 = currentState?.basicInfoNewEnq?.encryptedEnquiryRefId1
      let encryptedEnquiryRefId2 = currentState?.basicInfoNewEnq?.encryptedEnquiryRefId2

      let dialogeData = {
        message: `Are you sure you already upload all required documents!`,
        showConfirmPopup: true,
        isConfirm: true,
        isInfo: false,

      }

      const userResponse = await dispatch(toggleConfirmPopup(dialogeData));
      if (userResponse) {

        var res = await dispatch(saveCustomerConfirmation());
     
        if (res) {
          let infoDialoge = {
            message: `Your Application  has been Completed & is under process by our team, who will update you. Thank you for using our services!`,
            showConfirmPopup: true,
            isConfirm: false,
            isInfo: true,

          }
          await dispatch(getQuoteInformation({ encryptedEnquiryRefId1, encryptedEnquiryRefId2 }))
          await dispatch(toggleConfirmPopup(infoDialoge));
          // navigate('/customerportal')
          return true;

        }

      }

      return false;
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}

export const getfilteredNetworks = (data) => {
  return async function (dispatch, state) {
    try {
      dispatch(appActions.setLoading(true));
      let sr = await quotationService.getFilteredNetworks(data?.encryptedEnquiryRefId1, data?.encryptedEnquiryRefId2);
      if (sr.hasErrors) {
        dispatch(appActions.showValidationErrors(sr));
        return false;
      }
      if (sr.result) {
        await dispatch(setFilteredNetworks(sr.result));
      }
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}

export const setFilteredNetworks = (result) => {
  return {
    type: types.SET_FILTERED_NETWORKS,
    payload: result
  }
}

export const getMafAnswersEnd = (result) => {
  return {
    type: types.GET_MAF_ANSWERS_END,
    payload: result
  }
}

const getState = (state) => {
  return state.miCustomerSharedReducer;
};


export const updateModalState = ({ name, value }) => {
  return {
    type: types.UPDATE_MODAL_STATE,
    payload: { name, value }
  }
}

export const restoreState = (data) => {
  return {
    type: types.RESTORE_STATE,
    payload: data
  }
}
export function restoreStateAfterRedierct(data) {
  return async function (dispatch, state) {
    let currentState = getState(state());
    try {

      dispatch(appActions.setLoading(true));


      if (data) {
        //   dispatch(restoreState(data));
      }

      return true
    }
    catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}
export function processCOCBatchOnApprovals() {
  return async function (dispatch, state) {
    let currentState = getState(state());
    try {
      dispatch(appActions.setLoading(true));
      let sr = await quotationService.processCOCBatchOnApprovals(currentState?.basicInfoNewEnq?.enquiryId);
      await dispatch(getPremiumSummary());
      return true;
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}
export const saveUserInfoFromUaePass = (result) => {
  return {
    type: types.SAVE_UAE_PASS_USER_INFO,
    payload: result
  }
}
export function addUaePassLogs(log) {
  return async function (dispatch, state) {
    let currentState = getState(state());
    try {
      dispatch(appActions.setLoading(true));
      let sr = await quotationService.addUaePassLogApi(log);
      if (sr?.result) {
        await dispatch(saveUserInfoFromUaePass(sr.result));
      }

      if (sr.hasErrors) {
        dispatch(appActions.showValidationErrors(sr));
        return false;
      }
      return true
    } catch (e) {

      dispatch(appActions.handleError(e));
    } finally {
      localStorage.removeItem("myAppState");
      dispatch(appActions.setLoading(false));
    }
  }
}


export function getPlanTypeByNetId(networkId) {
  return async function (dispatch, state) {
    let currentState = getState(state());
    try {
      dispatch(appActions.setLoading(true));
      let sr = await quotationService.getPlanTypebyNetworkId(networkId ?? 0);
      if (!sr?.hasErrors) {
        dispatch(getPlanTypeByNetworkIdEnd(sr?.result));
        return true;
      }

      if (sr.hasErrors) {
        dispatch(appActions.showValidationErrors(sr));
        return false;
      }
      return true
    } catch (e) {

      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}

export function getLocationMaster(emirateType, emirate) {
  return async function (dispatch, state) {
    try {
      dispatch(appActions.setLoading(true));
      let sr = await quotationService.getLocationMaster(emirate);
      if (sr.result) {
        if (emirateType == "workEmirate") {
          dispatch(getWorkLocationMasterEnd(sr.result));
        }
        else if (emirateType == "residentEmirate") {
          dispatch(getResidentLocationMasterEnd(sr.result));
        }
        else if (emirateType == "visaEmirate") {
          dispatch(getVisaLocationMasterEnd(sr.result));
        }
      }
      if (sr.hasErrors) {
        dispatch(appActions.showValidationErrors(sr));
        return false;
      }
      return true;
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}

export const getWorkLocationMasterEnd = (result) => {
  return {
    type: types.GET_WORK_LOCATION_MASTER_END,
    result
  }
}

export const getResidentLocationMasterEnd = (result) => {
  return {
    type: types.GET_RESIDENT_LOCATION_MASTER_END,
    result
  }
}

export const setQuoteMemberSavedTrue = () => {
  return {
    type: types.SET_QUOTE_MEMBER_DOCS_SAVED_TRUE
  }
}

export const getVisaLocationMasterEnd = (result) => {
  return {
    type: types.GET_VISA_LOCATION_MASTER_END,
    result
  }
}

export const getCurrentCustomerInformationEnd = (data) => {
  console.log("action ", data);
  return {
    type: types.GET_CUSTOMER_INFORMATION_END_V1,
    payload: data
  }
}
export const getCustomerInformationById = (/* enquiryid */{ encryptedEnquiryRefId1, encryptedEnquiryRefId2 }) => {
  return async function (dispatch, state) {
    let currentState = getState(state());
    try {
      dispatch(appActions.setLoading(true));
      let params = {
        // "EnquiryId": enquiryid
        "EncryptedEnquiryRefId1": encryptedEnquiryRefId1,
        "EncryptedEnquiryRefId2": encryptedEnquiryRefId2,
      }
      let sr = await quotationService.getCustomerInformationById(params);
      if (sr.hasErrors) {
        dispatch(appActions.showValidationErrors(sr));
        return Promise.resolve(false);
      }
      await dispatch(getCurrentCustomerInformationEnd(sr?.result));
    } catch (e) {
      dispatch(appActions.handleError(e));
    }
    finally {
      dispatch(appActions.setLoading(false));
    }
  };
};
export const updateCustomerInformationParams = ({ name, value }) => {
  return {
    type: types.UPDATE_CUSTOMER_INFORMATION_PARAMS,
    payload: { name, value }
  }
}
export const customerInsuredInformationSave = (/* enquiryId,  */encryptedEnquiryRefId1, encryptedEnquiryRefId2) => {
  return async function (dispatch, state) {
    try {
      let currentState = getState(state());


      let params = currentState.customerInformation.insuredType == appConstants.INSURED_TYPE_INDIVIDUAL ? {
        "CustomerId": currentState.customerInformation.customerId == null || currentState.customerInformation.customerId == "" ? 0 : currentState.customerInformation.customerId,
        //"InsuredType": currentState.customerInformation.insuredType,
        "DOB": currentState.customerInformation.dateofBirth,
        "EmiratesId": currentState.customerInformation.emiratesId,
        //"PhoneNo": currentState.customerInformation.mobile,
        "Salutation": currentState.customerInformation.salutation,
        "FirstNameEN": currentState.customerInformation.firstName,
        "MiddleNameEN": currentState.customerInformation.middleName,
        "LastNameEN": currentState.customerInformation.lastName,
        "Gender": currentState.customerInformation.gender,
        "maritalStatus": currentState.customerInformation.maritalSatus,
        "Nationality": currentState.customerInformation.nationality,
        // "EmailId": currentState.customerInformation.email,
        //"CustomerInPolicyYN": currentState.customerInformation.customerInPolicyYN == null ? 'N' : 'Y',
        "Age": currentState.customerInformation.age,
        "EntityId": currentState.customerInformation.entityId,
        "EntityType": currentState.customerInformation.entityType,
        "PortalType": appConstants.PORTALTYPE_CORE,
        "SalaryBandTypeId": currentState.customerInformation.salaryBandTypeId,
        "Address": currentState.customerInformation.address,
        "PoBox": currentState.customerInformation.poBox,
        // "EnquiryId": enquiryId,
        "EncryptedEnquiryRefId1": encryptedEnquiryRefId1,
        "EncryptedEnquiryRefId2": encryptedEnquiryRefId2,
      }

        :
        {
          "CustomerId": currentState.customerInformation.customerId == null || currentState.customerInformation.customerId == "" ? 0 : currentState.customerInformation.customerId,
          //"InsuredType": currentState.customerInformation.insuredType,
          "CompanyCRNo": currentState.customerInformation.companyCRNumber,
          "FulNameEN": currentState.customerInformation.fullName,
          "TradeLicenseNo": currentState.customerInformation.tradeLicenseNo,
          "TradeLicenseExpirayDate": currentState.customerInformation.tradeLicenseExpiryDate,
          "EntityId": currentState.customerInformation.entityId,
          "EntityType": currentState.customerInformation.entityType,
          //"EmailId": currentState.customerInformation.policyEmail,
          // "PhoneNo": currentState.customerInformation.companyMobile,
          "PortalType": appConstants.PORTALTYPE_CORE,
          // "EnquiryId": enquiryId,
          "EncryptedEnquiryRefId1": encryptedEnquiryRefId1,
          "EncryptedEnquiryRefId2": encryptedEnquiryRefId2,

        }

      dispatch(appActions.setLoading(true));
      let sr = await quotationService.customerInsuredInformationSave(params);
      if (sr.hasErrors) {
        dispatch(appActions.showValidationErrors(sr));
        return Promise.resolve(false);
      }
      let dialogeData = {
        message: ` Successfully Saved!`,
        showConfirmPopup: true,
        isConfirm: false,
        isInfo: true,

      }
      await dispatch(toggleConfirmPopup(dialogeData));
      // dispatch(appActions.showMessage("Saved Customer Information.", { buttons: ['Ok'] }));

      return Promise.resolve(true);
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  };
};
export const showTermsAndComdPopapBasicInfo = ({ name, value, message }) => {
  return async function (dispatch, state) {
    try {

      // let confirm = await dispatch(appActions.showMessage(message,
      //   { buttons: ['Yes', 'Close'] }));
      // if (confirm === 'Close') {
      //   let name = "termsCond";
      //   let value = false;
      // }
      // await dispatch(actions.updatePaymentTransactionsParams({ name, value }));

      let dialogeData = {
        message: message,
        showConfirmPopup: true,
        isConfirm: true,
        isInfo: false,
        isComp: false,
        title: 'Terms & Condition'
      }

      const userResponse = await dispatch(toggleConfirmPopup(dialogeData));




      // await dispatch(updatePaymentTransactionsParams({ name: 'termsCond', value: userResponse }));
      if (userResponse == true) {
        return true
      }
      else {
        return false
      }




    }

    catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}

export const saveTermsAndConditionsResponse = (termsCond) => {
  return async function (dispatch, state) {
    try {
      let currentState = getState(state());
      let encryptedEnquiryRefId1 = currentState.basicInfoNewEnq.encryptedEnquiryRefId1;
      let encryptedEnquiryRefId2 = currentState.basicInfoNewEnq.encryptedEnquiryRefId2;
      termsCond = termsCond ?? currentState.payment.termsCond;
      dispatch(appActions.setLoading(true));
      let sr = await quotationService.saveTermsAndConditionsResponse({ encryptedEnquiryRefId1, encryptedEnquiryRefId2, "IsAccepted": termsCond });
      if (sr.hasErrors) {
        dispatch(appActions.showValidationErrors(sr));
        return false;
      }
      return true
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}

export const saveCustomerConfirmation = () => {
  return async function (dispatch, state) {
    try {
      let currentState = getState(state());
      let encryptedEnquiryRefId1 = currentState.basicInfoNewEnq.encryptedEnquiryRefId1;
      let encryptedEnquiryRefId2 = currentState.basicInfoNewEnq.encryptedEnquiryRefId2;
      dispatch(appActions.setLoading(true));
      let sr = await quotationService.saveCustomerConfirmation({ encryptedEnquiryRefId1, encryptedEnquiryRefId2 });
      if (sr.hasErrors) {
        dispatch(appActions.showValidationErrors(sr));
        return false;
      }
      return true
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setLoading(false));
    }
  }
}
///B2C SOURCE TRACKER///
export const setUtmSource = (utmSource) => {
    return {
    type: types.SET_UTM_SOURCE,
    payload: utmSource
  }
};
///B2C SOURCE TRACKER///



